import { Component, Element, h, Host, Listen, Prop } from "@stencil/core";

/**
 * @slot (default) - Slot for the card content (`<ux-iws-sf-card-content>`)
 * @slot image - Slot for the card image (`<ux-iws-sf-card-image>`)
 * @slot cta - Slot for the call-to-action button (`<ux-button>`)
 */
@Component({
    tag: "ux-iws-sf-card",
    styleUrl: "sf-card.scss",
    shadow: true,
})
export class SfCard {
    /** The host element of the component */
    @Element() host: HTMLUxIwsSfCardElement;

    /** Whether the card should be rendered as an article or section element. */
    @Prop() as: "article" | "section" = "article";

    /** The label for the card, also used for accessibility. */
    @Prop() label: string = "";

    /** Layout of the card, either horizontal or vertical. */
    @Prop({ mutable: true, reflect: true }) layout: "horizontal" | "vertical" =
        "vertical";

    @Listen("resize", { target: "window" })
    handleResize() {
        this.layout = this.containerWidth < 480 ? "vertical" : "horizontal";
    }

    private get containerWidth(): number {
        return this.host.offsetWidth || 0;
    }

    componentDidLoad() {
        // Ensure the layout is set after the component has rendered
        window.setTimeout(() => this.handleResize(), 0);
    }

    render() {
        const hasCtaSlot = !!this.host.querySelector("[slot='cta']");
        const hasImageSlot = !!this.host.querySelector("[slot='image']");
        const TagName = this.as;
        return (
            <Host>
                <TagName class="grid" aria-label={this.label || undefined}>
                    {hasImageSlot && (
                        <div class="image">
                            <slot name="image" />
                        </div>
                    )}
                    <div class="content" part="content">
                        <slot />
                    </div>
                    {hasCtaSlot && (
                        <div class="cta">
                            <slot name="cta" />
                        </div>
                    )}
                </TagName>
            </Host>
        );
    }
}
